import * as t from "io-ts"


export const IsPlain =
    (function (): t.Type<true, undefined, unknown> {
        const trueLiteral = t.literal(true);
        return new t.Type(
            "IsPlain",
            trueLiteral.is,
            (u, c) => u === undefined ? t.success(true) : trueLiteral.validate(u, c),
            _ => undefined
        );
    })();
export type IsPlain = t.TypeOf<typeof IsPlain>

export const NotPlain =
    (function (): t.Type<false, undefined, unknown> {
        const falseLiteral = t.literal(false);
        return new t.Type(
            "NotPlain",
            falseLiteral.is,
            (u, c) => u === undefined ? t.success(false) : falseLiteral.validate(u, c),
            _ => undefined
        );
    })();
export type NotPlain = t.TypeOf<typeof NotPlain>